import { UserContext } from '@/context/user.context';
import { useContext } from 'react';

export const useGetUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useGetUser must be used within a UserProvider');
  }

  return context;
};
